import zh from './lang/zh';
import jp from './lang/jp';
import en from './lang/en';

const i18nMap = {
    "zh": zh,
    'jp': jp,
    'en': en
};
export default i18nMap;



// WEBPACK FOOTER //
// ./src/i18n/i18nMapLoader.js